<template>
  <div class="badge" :class="[name, inverse ? 'inverse' :'', brown ? 'brown':'', sel ? 'sel': ''] " :title="name" v-on:click.stop="goUrl" >
    <a :href="url" ref="badgeLink" style="display:none" target="_blank">{{ name }}</a>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    url: String,
    inverse: Boolean,
    brown: Boolean,
    sel: Boolean
  },
  methods: {
    goUrl: function () {
      this.$refs.badgeLink.click()
      this.$k.sendSocialEvent(this.name)
    }
  }
}
</script>
<style scoped>
.badge{
  cursor:pointer;
  background-image:url('../../assets/img/facebook-gold.svg');
  background-repeat: no-repeat;
  background-size:contain;
  background-position: center bottom;
  width:30px;
  height:30px;
  display:inline-block;
  margin:15px;
}

.badge.large{
  width:40px;
  height:40px;
}

.badge:first-child{
  margin-left:0;
}

.badge:last-child{
  margin-right:0;
}

.badge.facebook.inverse{
  background-image:url('../../assets/img/facebook-white.svg');
}
.badge.facebook.brown{
  background-image:url('../../assets/img/facebook-brown.svg');
}

.badge.facebook:hover, .badge.facebook.sel{
  background-image:url('../../assets/img/facebook-red.svg');
}

.badge.twitter{
  background-image:url('../../assets/img/twitter-gold.svg');
}
.badge.twitter.inverse{
  background-image:url('../../assets/img/twitter-white.svg');
}
.badge.twitter.brown{
  background-image:url('../../assets/img/twitter-brown.svg');
}
.badge.twitter:hover, .badge.twitter.sel{
  background-image:url('../../assets/img/twitter-red.svg');
}
.badge.linkedin{
  background-image:url('../../assets/img/linkedin-gold.svg');
}
.badge.linkedin.inverse{
  background-image:url('../../assets/img/linkedin-white.svg');
}
.badge.linkedin:hover{
  background-image:url('../../assets/img/linkedin-red.svg');
}

.badge.pinterest{
  background-image:url('../../assets/img/pinterest-gold.svg');
}
.badge.pinterest.inverse{
  background-image:url('../../assets/img/pinterest-white.svg');
}
.badge.pinterest.brown{
  background-image:url('../../assets/img/pinterest-brown.svg');
}
.badge.pinterest:hover, .badge.pinterest.sel{
  background-image:url('../../assets/img/pinterest-red.svg');
}

.badge.instagram{
  background-image:url('../../assets/img/instagram-gold.svg');
}
.badge.instagram.inverse{
  background-image:url('../../assets/img/instagram-white.svg');
}

.badge.instagram.brown{
  background-image:url('../../assets/img/instagram-brown.svg');
}

.badge.instagram:hover, .badge.instagram.sel{
  background-image:url('../../assets/img/instagram-red.svg');
}



</style>
